export const categories = [
  {
    id: 'qinggan',
    name: '情感天地',
    slug: 'qinggan',
    description: '探讨爱情、婚姻、亲密关系等情感话题，分享心动故事与心灵感悟',
    icon: 'ri-heart-line',
    color: 'primary',
    articleCount: 128,
  },
  {
    id: 'shenghuo',
    name: '生活美学',
    slug: 'shenghuo',
    description: '发现生活中的美好瞬间，分享家居、美食、旅行等生活方式灵感',
    icon: 'ri-home-heart-line',
    color: 'accent',
    articleCount: 96,
  },
  {
    id: 'chengzhang',
    name: '个人成长',
    slug: 'chengzhang',
    description: '自我提升、职场进阶、心理建设，陪伴每一位用户遇见更好的自己',
    icon: 'ri-seedling-line',
    color: 'secondary',
    articleCount: 85,
  },
  {
    id: 'yule',
    name: '娱乐八卦',
    slug: 'yule',
    description: '最新娱乐资讯、明星动态、热门综艺剧集讨论，满足你的吃瓜需求',
    icon: 'ri-fire-line',
    color: 'primary',
    articleCount: 156,
  },
  {
    id: 'dushu',
    name: '读书分享',
    slug: 'dushu',
    description: '好书推荐、读书笔记、阅读感悟，与志同道合的书友一起畅游书海',
    icon: 'ri-book-open-line',
    color: 'accent',
    articleCount: 72,
  },
  {
    id: 'jiankang',
    name: '健康养生',
    slug: 'jiankang',
    description: '关注身心健康，分享养生知识、运动健身和健康饮食的实用方法',
    icon: 'ri-heart-pulse-line',
    color: 'secondary',
    articleCount: 64,
  },
  {
    id: 'keji',
    name: '科技数码',
    slug: 'keji',
    description: '数码产品评测、科技趋势解读、实用软件推荐，走在科技前沿',
    icon: 'ri-computer-line',
    color: 'primary',
    articleCount: 53,
  },
  {
    id: 'sheying',
    name: '摄影艺术',
    slug: 'sheying',
    description: '摄影技巧分享、作品赏析、器材讨论，用镜头记录美好世界',
    icon: 'ri-camera-line',
    color: 'accent',
    articleCount: 41,
  },
];

export const articles = [
  {
    id: 1,
    title: '爱情岛论坛独家提供：如何在忙碌生活中经营一段高质量亲密关系',
    slug: 'busy-life-quality-relationship',
    excerpt: '现代生活节奏越来越快，如何在繁忙的工作和生活中，依然保持亲密关系的温度和质量？爱情岛论坛独家提供这份实用指南，帮助你找到平衡点。',
    content: `
      <p>在这个快节奏的时代，我们常常被工作、社交和各种琐事占据，留给亲密关系的时间越来越少。但真正健康的关系恰恰需要用心经营。爱情岛论坛独家提供以下建议，希望能帮助你找到属于自己的答案。</p>
      
      <h2>一、质量重于数量</h2>
      <p>很多人以为，多花时间在一起就能维系好感情。但其实，相处的质量远比数量重要。每天15分钟的专注交流，胜过心不在焉地共处3小时。</p>
      <p>尝试设定"无手机时间"，在这段时间里，放下所有电子设备，真正地倾听对方，分享彼此的想法和感受。爱情岛论坛的会员们普遍反映，这个小小的改变带来了意想不到的积极效果。</p>
      
      <h2>二、保持独立的自我</h2>
      <p>健康的亲密关系不是两个人的融合，而是两个独立个体的并肩前行。保持自己的兴趣爱好、社交圈子和个人空间，不仅不会削弱感情，反而能让关系更加稳固。</p>
      
      <h2>三、学会表达需求</h2>
      <p>很多时候，关系中的矛盾源于期待对方"读心"。但没有人能完全读懂另一个人的想法。学会清晰、温和地表达自己的需求，是维系良好关系的关键技能。</p>
      
      <h2>四、定期创造惊喜</h2>
      <p>长期关系中，新鲜感需要主动创造。不一定需要多么盛大的仪式，一张手写的便条、一顿精心准备的早餐，都能让对方感受到被珍视的温暖。</p>
      
      <p>爱情岛论坛独家提供的这些内容，都是经过数千位会员实践验证的有效方法。希望每一位读者都能在这里找到成长的力量，经营出属于自己的幸福关系。</p>
    `,
    categoryId: 'qinggan',
    categoryName: '情感天地',
    author: '爱情岛编辑团队',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20editorial%20team%20avatar%20in%20warm%20coral%20tones%2C%20simple%20minimal%20style%2C%20clean%20background%2C%20editorial%20illustration&width=100&height=100&seq=avatar-editor-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20romantic%20couple%20sitting%20on%20a%20park%20bench%20at%20sunset%2C%20soft%20golden%20light%2C%20minimal%20artistic%20style%2C%20gentle%20atmosphere%2C%20editorial%20illustration%20with%20clean%20composition&width=1600&height=900&seq=article-cover-01&orientation=landscape',
    publishedAt: '2026-08-03',
    readCount: 12856,
    likeCount: 2341,
    commentCount: 567,
    tags: ['亲密关系', '情感经营', '爱情指南'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 2,
    title: '爱情岛独家资源：2026年必读的10本情感成长类好书推荐',
    slug: '2026-must-read-emotional-books',
    excerpt: '阅读是最好的自我投资。爱情岛论坛精选了2026年最值得阅读的10本情感成长类好书，涵盖亲密关系、自我认知、沟通技巧等多个维度。',
    content: `
      <p>在信息爆炸的时代，静下心来读一本好书变得愈发珍贵。爱情岛论坛独家整理了2026年最值得阅读的情感成长类书籍，为你提供优质的阅读选择。</p>
      
      <h2>1. 《亲密关系中的沟通艺术》</h2>
      <p>这本书深入探讨了伴侣之间有效沟通的核心技巧，从倾听、表达到冲突解决，提供了一个完整的沟通框架。</p>
      
      <h2>2. 《自我觉醒：找到真正的自己》</h2>
      <p>在进入亲密关系之前，了解自己、接纳自己是至关重要的第一步。这本书帮助读者探索内心，建立健康的自我认知。</p>
      
      <h2>3. 《爱的五种语言》</h2>
      <p>经典之作，帮助读者理解自己和伴侣表达爱的方式差异，找到最适合彼此的爱的沟通模式。</p>
      
      <p>更多精彩书单，欢迎加入爱情岛论坛社区，与数万名书友一起交流读书心得。</p>
    `,
    categoryId: 'dushu',
    categoryName: '读书分享',
    author: '书海领航员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Book%20lover%20avatar%20illustration%20with%20warm%20amber%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=avatar-reader-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20reading%20nook%20with%20stack%20of%20books%20and%20warm%20lamp%20light%2C%20autumn%20vibes%2C%20minimal%20artistic%20style%2C%20editorial%20photography&width=1600&height=900&seq=article-cover-02&orientation=landscape',
    publishedAt: '2026-08-02',
    readCount: 8923,
    likeCount: 1876,
    commentCount: 342,
    tags: ['读书推荐', '情感成长', '2026书单'],
    isFeatured: true,
    isHot: false,
  },
  {
    id: 3,
    title: '爱情岛论坛独家揭秘：高质量独处如何改变你的人生轨迹',
    slug: 'high-quality-alone-time',
    excerpt: '独处不等于孤独。爱情岛论坛与心理学专家对话，深入探讨高质量独处对个人成长的深远影响，以及如何培养这一重要能力。',
    content: `
      <p>在这个社交媒体的时代，我们似乎总是在连接，却很少真正地与自己相处。爱情岛论坛独家邀请心理学专家，为你解读独处的力量。</p>
      <h2>独处与孤独的区别</h2>
      <p>独处是一种主动选择，是享受与自己相处的时光；而孤独是一种被动状态，是渴望连接却无法实现的空虚感。两者有着本质的区别。</p>
      <h2>高质量独处的益处</h2>
      <p>研究表明，定期进行高质量的独处可以有效提升创造力、增强自我认知、降低焦虑水平，甚至改善人际关系质量。</p>
    `,
    categoryId: 'chengzhang',
    categoryName: '个人成长',
    author: '心灵探索者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Mind%20explorer%20avatar%20in%20warm%20brown%20tones%2C%20minimal%20style%2C%20clean%20background%2C%20editorial%20illustration&width=100&height=100&seq=avatar-explorer-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20person%20meditating%20peacefully%20in%20a%20sunlit%20room%20with%20plants%2C%20minimal%20aesthetic%2C%20warm%20natural%20light%2C%20editorial%20photography%20style&width=1600&height=900&seq=article-cover-03&orientation=landscape',
    publishedAt: '2026-08-01',
    readCount: 15672,
    likeCount: 3421,
    commentCount: 891,
    tags: ['个人成长', '独处', '心理健康'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 4,
    title: '2026夏季最火综艺盘点：爱情岛论坛独家整理不可错过的精彩内容',
    slug: '2026-summer-variety-show-guide',
    excerpt: '炎炎夏日，宅家追综才是正经事！爱情岛论坛为你整理2026夏季最值得观看的综艺节目，从恋爱观察到音乐竞技，总有一款适合你。',
    content: `
      <p>2026年的夏天，综艺市场依然精彩纷呈。爱情岛论坛为大家梳理了本季最热门的几档节目。</p>
      <h2>恋爱观察类综艺持续火爆</h2>
      <p>今年夏天，多档恋爱观察类节目强势回归，在社交媒体上引发热烈讨论。真实的情感互动和出人意料的情节发展，让观众欲罢不能。</p>
      <h2>音乐竞技节目创新升级</h2>
      <p>音乐类综艺也在不断创新，从赛制到舞台设计都让人眼前一亮。原创音乐的比重增加，让节目更加有温度和深度。</p>
    `,
    categoryId: 'yule',
    categoryName: '娱乐八卦',
    author: '娱乐先锋',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Entertainment%20reporter%20avatar%20in%20warm%20coral%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=avatar-ent-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20TV%20studio%20with%20stage%20lights%20and%20entertainment%20vibe%2C%20minimal%20artistic%20style%2C%20warm%20atmosphere%2C%20editorial%20photography&width=1600&height=900&seq=article-cover-04&orientation=landscape',
    publishedAt: '2026-07-30',
    readCount: 20345,
    likeCount: 4567,
    commentCount: 1234,
    tags: ['综艺推荐', '2026夏季', '娱乐资讯'],
    isFeatured: false,
    isHot: true,
  },
  {
    id: 5,
    title: '爱情岛论坛会员专享：打造温馨小家的5个设计灵感',
    slug: 'cozy-home-design-inspiration',
    excerpt: '家是心灵的港湾。爱情岛论坛为你精选5个居家设计灵感，用简单的方式打造一个温馨舒适的生活空间。',
    content: `
      <p>一个温馨的家，不需要多么豪华的装修，关键在于用心和细节。以下是爱情岛论坛独家整理的居家设计灵感。</p>
      <h2>1. 暖色调灯光营造氛围</h2>
      <p>灯光是家居氛围的灵魂。选择2700K-3000K色温的暖光灯，可以让整个空间瞬间变得温馨而舒适。</p>
      <h2>2. 绿植赋予生命力</h2>
      <p>几盆精心打理的绿植，能为家注入自然的生机。选择好养护的品种，如龟背竹、琴叶榕等。</p>
    `,
    categoryId: 'shenghuo',
    categoryName: '生活美学',
    author: '生活美学家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Lifestyle%20designer%20avatar%20in%20warm%20amber%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=avatar-life-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20Scandinavian%20style%20living%20room%20with%20warm%20lighting%20and%20plants%2C%20minimal%20design%2C%20soft%20textures%2C%20editorial%20interior%20photography&width=1600&height=900&seq=article-cover-05&orientation=landscape',
    publishedAt: '2026-07-29',
    readCount: 11234,
    likeCount: 2890,
    commentCount: 456,
    tags: ['家居设计', '生活美学', '温馨小屋'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 6,
    title: '爱情岛论坛独家资源：30天自我提升计划，遇见更好的自己',
    slug: '30-day-self-improvement-plan',
    excerpt: '改变从来不是一蹴而就的。爱情岛论坛为你设计了一份30天自我提升计划，每天一个小目标，30天后收获全新的自己。',
    content: `
      <p>想要改变，但不知从何开始？爱情岛论坛为你准备了一份循序渐进的30天自我提升计划。</p>
      <h2>第一周：建立基础习惯</h2>
      <p>从早睡早起、规律饮食开始，奠定健康生活的基础。每天写下一件感恩的事，培养积极心态。</p>
      <h2>第二周：拓展认知边界</h2>
      <p>每天阅读30分钟，学习一个新知识点。尝试用不同的角度看待问题。</p>
    `,
    categoryId: 'chengzhang',
    categoryName: '个人成长',
    author: '成长导师',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Growth%20coach%20avatar%20in%20warm%20brown%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=avatar-growth-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20person%20journaling%20at%20a%20clean%20desk%20with%20morning%20sunlight%2C%20minimal%20aesthetic%2C%20warm%20tones%2C%20editorial%20photography&width=1600&height=900&seq=article-cover-06&orientation=landscape',
    publishedAt: '2026-07-28',
    readCount: 18765,
    likeCount: 4567,
    commentCount: 789,
    tags: ['自我提升', '成长计划', '习惯养成'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 7,
    title: '摄影新手必看：爱情岛论坛独家整理手机摄影入门技巧',
    slug: 'mobile-photography-beginner-tips',
    excerpt: '不需要昂贵的器材，一部手机也能拍出惊艳的照片。爱情岛论坛整理了一份手机摄影入门指南，助你快速上手。',
    content: `
      <p>随着手机摄像头的不断进化，用手机拍出好照片已经不再是专业摄影师的专利。以下是爱情岛论坛整理的核心技巧。</p>
      <h2>构图是灵魂</h2>
      <p>掌握三分法、引导线、对称构图等基本原则，你的照片立即提升一个档次。</p>
      <h2>光线的魔法</h2>
      <p>学会观察和利用自然光，黄金时段（日出后和日落前1小时）的光线尤为迷人。</p>
    `,
    categoryId: 'sheying',
    categoryName: '摄影艺术',
    author: '光影捕手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Photographer%20avatar%20in%20warm%20amber%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=avatar-photo-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20taking%20photo%20of%20beautiful%20sunset%20landscape%2C%20minimal%20artistic%20style%2C%20warm%20golden%20light%2C%20editorial%20photography&width=1600&height=900&seq=article-cover-07&orientation=landscape',
    publishedAt: '2026-07-27',
    readCount: 9876,
    likeCount: 2134,
    commentCount: 345,
    tags: ['手机摄影', '入门教程', '摄影技巧'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 8,
    title: '爱情岛论坛社区热议：现代人的社交困境与破局之道',
    slug: 'modern-social-dilemma-solutions',
    excerpt: '在连接过剩的时代，真正的深度社交反而成了一种奢侈。爱情岛论坛社区会员热议这个现象，并分享了自己的破局经验。',
    content: `
      <p>社交媒体的泛滥让"连接"变得前所未有的便利，但真实而有深度的社交关系却在减少。爱情岛论坛的会员们分享了他们的观察和思考。</p>
      <h2>为什么我们感到更孤独了？</h2>
      <p>表面上看，我们每天通过微信、朋友圈和各种社交平台与数十上百人保持联系，但这些浅层互动并不能满足我们对深度连接的需求。</p>
      <h2>从线上到线下的转变</h2>
      <p>许多爱情岛论坛会员分享了他们从线上社交转向线下深度交往的经历，带来了意想不到的积极变化。</p>
    `,
    categoryId: 'qinggan',
    categoryName: '情感天地',
    author: '社区观察者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Social%20observer%20avatar%20in%20warm%20coral%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=avatar-social-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=People%20having%20meaningful%20conversation%20in%20a%20cozy%20cafe%2C%20warm%20light%2C%20minimal%20artistic%20style%2C%20editorial%20photography&width=1600&height=900&seq=article-cover-08&orientation=landscape',
    publishedAt: '2026-07-26',
    readCount: 14321,
    likeCount: 3210,
    commentCount: 1023,
    tags: ['社交困境', '深度连接', '社区讨论'],
    isFeatured: false,
    isHot: true,
  },
  {
    id: 9,
    title: '爱情岛论坛独家福利：春季养生食谱大公开，吃出好气色',
    slug: 'spring-wellness-recipes',
    excerpt: '顺应季节变化调整饮食，是养生的重要原则。爱情岛论坛为你整理了一份春季养生食谱，简单易做又美味健康。',
    content: `
      <p>春天是万物复苏的季节，也是调理身体的最佳时机。爱情岛论坛整理的这份春季养生食谱，结合了传统中医理论与现代营养学。</p>
      <h2>养肝护肝的绿色食谱</h2>
      <p>春季对应肝脏，多吃绿色蔬菜有助于疏肝理气。推荐菠菜、芹菜、韭菜等应季蔬菜。</p>
      <h2>温和滋补的汤品推荐</h2>
      <p>春季不宜大补，应以温和的汤品为主。枸杞菊花茶、山药排骨汤都是不错的选择。</p>
    `,
    categoryId: 'jiankang',
    categoryName: '健康养生',
    author: '健康达人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Health%20enthusiast%20avatar%20in%20warm%20brown%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=avatar-health-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Fresh%20spring%20vegetables%20and%20healthy%20food%20on%20a%20wooden%20table%2C%20natural%20light%2C%20minimal%20style%2C%20editorial%20food%20photography&width=1600&height=900&seq=article-cover-09&orientation=landscape',
    publishedAt: '2026-07-25',
    readCount: 7654,
    likeCount: 1654,
    commentCount: 234,
    tags: ['养生食谱', '春季养生', '健康饮食'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 10,
    title: '爱情岛论坛独家测评：2026年最值得入手的数码好物推荐',
    slug: '2026-best-digital-gadgets',
    excerpt: '科技改变生活。爱情岛论坛数码频道为大家带来2026上半年最值得关注的数码产品深度测评，帮你理性消费。',
    content: `
      <p>2026年上半年，数码市场涌现了不少令人眼前一亮的产品。爱情岛论坛数码频道经过一个月的深度体验，为大家带来真实客观的测评。</p>
      <h2>智能手机新趋势</h2>
      <p>今年的旗舰手机在AI能力和影像系统上有了质的飞跃，但价格也水涨船高。我们帮你分析哪些升级真正值得买单。</p>
      <h2>智能家居生态</h2>
      <p>跨品牌互联互通成为2026年智能家居的关键词，兼容性大幅提升。</p>
    `,
    categoryId: 'keji',
    categoryName: '科技数码',
    author: '数码极客',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Tech%20geek%20avatar%20in%20warm%20coral%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=avatar-tech-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20digital%20gadgets%20neatly%20arranged%20on%20a%20minimal%20desk%2C%20warm%20lighting%2C%20editorial%20product%20photography%2C%20clean%20composition&width=1600&height=900&seq=article-cover-10&orientation=landscape',
    publishedAt: '2026-07-24',
    readCount: 12345,
    likeCount: 2789,
    commentCount: 567,
    tags: ['数码测评', '产品推荐', '2026好物'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 11,
    title: '爱情岛论坛独家提供：写给所有在爱情中迷茫的你',
    slug: 'letter-to-those-lost-in-love',
    excerpt: '爱情从来不是一道有标准答案的题目。爱情岛论坛收到许多读者的来信，诉说他们在爱情中的困惑与迷茫，我们想对你说——',
    content: `
      <p>亲爱的读者，如果你正在爱情中感到迷茫，请相信你不是一个人。爱情岛论坛每天都收到许多类似的来信，我们想借此机会，与你分享一些真心话。</p>
      <h2>迷茫是正常的</h2>
      <p>在一段关系中感到困惑和不确定，这恰恰说明你在认真对待这段感情。真正的问题不在于有没有迷茫，而在于如何面对迷茫。</p>
      <h2>倾听内心的声音</h2>
      <p>很多时候，答案已经在你的心中。只是外界的噪音太大，让你听不到自己的声音。试着安静下来，问自己真正想要的是什么。</p>
    `,
    categoryId: 'qinggan',
    categoryName: '情感天地',
    author: '爱情岛编辑部',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Editorial%20team%20avatar%20illustration%20in%20warm%20coral%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=avatar-editor-02&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20lonely%20figure%20looking%20at%20sunset%20over%20the%20ocean%2C%20hopeful%20atmosphere%2C%20warm%20golden%20light%2C%20minimal%20artistic%20style&width=1600&height=900&seq=article-cover-11&orientation=landscape',
    publishedAt: '2026-07-23',
    readCount: 22341,
    likeCount: 5678,
    commentCount: 1890,
    tags: ['情感困惑', '爱情迷茫', '心灵感悟'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 12,
    title: '旅行不止打卡：爱情岛论坛独家分享慢旅行哲学',
    slug: 'slow-travel-philosophy',
    excerpt: '真正的旅行不是匆匆打卡，而是用心感受每一个目的地。爱情岛论坛与旅行达人对话，分享慢旅行的独特魅力。',
    content: `
      <p>在社交媒体时代，"打卡式旅行"似乎成了主流。但越来越多的旅行者开始反思：旅行的意义究竟是什么？</p>
      <h2>什么是慢旅行？</h2>
      <p>慢旅行不是走得慢，而是用心去感受。在一个地方停留更久，深入体验当地的生活和文化，而不是匆匆掠过。</p>
      <h2>慢旅行的收获</h2>
      <p>当你放慢脚步，你会发现那些被忽略的美好——清晨的市集、傍晚的街角、当地人脸上的笑容。</p>
    `,
    categoryId: 'shenghuo',
    categoryName: '生活美学',
    author: '旅行诗人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Travel%20poet%20avatar%20in%20warm%20amber%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=avatar-travel-01&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20quiet%20cobblestone%20street%20in%20a%20European%20village%20at%20golden%20hour%2C%20minimal%20artistic%20style%2C%20warm%20atmosphere%2C%20editorial%20travel%20photography&width=1600&height=900&seq=article-cover-12&orientation=landscape',
    publishedAt: '2026-07-22',
    readCount: 9876,
    likeCount: 2100,
    commentCount: 345,
    tags: ['慢旅行', '旅行哲学', '生活方式'],
    isFeatured: false,
    isHot: false,
  },
];

export const featuredArticles = articles.filter((a) => a.isFeatured);
export const hotArticles = articles.filter((a) => a.isHot);

export function getArticlesByCategory(categorySlug: string) {
  return articles.filter((a) => a.categoryId === categorySlug);
}

export function getArticleById(id: number) {
  return articles.find((a) => a.id === id);
}

export function getCategoryBySlug(slug: string) {
  return categories.find((c) => c.slug === slug);
}

export function getRelatedArticles(articleId: number, categoryId: string, limit = 4) {
  return articles
    .filter((a) => a.id !== articleId && a.categoryId === categoryId)
    .slice(0, limit);
}

export const faqs = [
  {
    question: '爱情岛论坛是什么？',
    answer: '爱情岛论坛是一个专注于情感、生活、成长等领域的优质内容社区平台，汇聚海量精选信息，为广大用户提供独家优质内容和社区互动服务。',
  },
  {
    question: '如何注册成为爱情岛论坛会员？',
    answer: '您可以通过爱情岛论坛首页的注册入口，使用手机号或邮箱快速完成注册，即可成为爱情岛论坛会员，畅享独家提供的丰富内容与社区互动服务。',
  },
  {
    question: '爱情岛论坛的内容是否免费？',
    answer: '爱情岛论坛大部分内容对所有用户免费开放。部分独家深度内容和会员专享福利需要注册成为会员后即可访问，我们致力于为用户提供最有价值的阅读体验。',
  },
  {
    question: '如何在爱情岛论坛发布内容？',
    answer: '注册成为爱情岛论坛会员后，您可以在个人中心找到发布入口。我们欢迎每一位用户分享自己的故事、见解和经验，与社区成员一起交流互动。',
  },
  {
    question: '爱情岛论坛的独家资源有哪些？',
    answer: '爱情岛论坛独家资源包括：深度情感分析文章、专家访谈、会员专享课程、社区活动、以及定期的线上分享会等，涵盖情感、成长、生活、娱乐等多个领域。',
  },
  {
    question: '如何联系爱情岛论坛的运营团队？',
    answer: '您可以通过关于我们页面的联系方式，或发送邮件至官方邮箱与我们取得联系。我们珍视每一位用户的反馈和建议。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20in%20warm%20coral%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=testimonial-01&orientation=squarish',
    content: '加入爱情岛论坛已经两年了，这里不仅有好文章，更有一群温暖的朋友。每次心情低落的时候，来这里看看大家的分享，总能找到力量。',
    role: '资深会员',
  },
  {
    id: 2,
    name: '星辰大海',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20in%20warm%20amber%20tones%2C%20minimal%20style%2C%20clean%20background&width=100&height=100&seq=testimonial-02&orientation=squarish',
    content: '爱情岛论坛的内容质量真的很高，每一篇文章都能感受到编辑团队的用心。特别是情感天地栏目，帮我度过了很多迷茫的时刻。',
    role: '活跃用户',
  },
  {
    id: 3,
    name: '暖阳',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20in%20warm%20brown%20tones%2C%20minimal%20style%2C%20clean%20background%2C%20gentle%20smile&width=100&height=100&seq=testimonial-03&orientation=squarish',
    content: '最喜欢爱情岛论坛的个人成长板块，30天自我提升计划真的改变了我的生活。现在每天都期待着新的内容更新。',
    role: 'VIP会员',
  },
];

export const stats = {
  totalArticles: 1280,
  totalMembers: 586000,
  dailyActive: 32000,
  totalViews: 12800000,
};